import {
  GET_SOCIETY,
  GET_SOCIETY_SUCCESS,
  GET_SOCIETY_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",
  societies: [],
}

const society = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SOCIETY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_SOCIETY_SUCCESS:
      return {
        ...state,
        societies: action.payload,
        loading: false,
      }
    case GET_SOCIETY:
      return {
        ...state,
        societies: [],
        loading: true,
      }
    default:
      return state
  }
}

export default society
